export const VendorConstant = {
  VENDOR_CITY_SAGA: "VENDOR_CITY_SAGA",
  VENDOR_CITY_REQUEST: "VENDOR_CITY_REQUEST",
  VENDOR_CITY_RESPONSE: "VENDOR_CITY_RESPONSE",
  VENDOR_CITY_API: "/cities",

  VENDOR_SEEALLRES_SAGA: "VENDOR_SEEALLRES_SAGA",
  VENDOR_SEEALLRES_REQUEST: "VENDOR_SEEALLRES_REQUEST",
  VENDOR_SEEALLRES_RESPONSE: "VENDOR_SEEALLRES_RESPONSE",
  VENDOR_SEEALLRES_API: "/vendors",

  VENDOR_COUNT_SAGA: "VENDOR_COUNT_SAGA",
  VENDOR_COUNT_REQUEST: "VENDOR_COUNT_REQUEST",
  VENDOR_COUNT_RESPONSE: "VENDOR_COUNT_RESPONSE",
  VENDOR_COUNT_API: "/vendors",

  // approve enable disable

  APPROVE_ENABLE_DISABLE_SAGA: "APPROVE_ENABLE_DISABLE_SAGA",
  APPROVE_ENABLE_DISABLE_REQUEST: "APPROVE_ENABLE_DISABLE_REQUEST",
  APPROVE_ENABLE_DISABLE_RESPONSE: "APPROVE_ENABLE_DISABLE_RESPONSE",
  APPROVE_ENABLE_DISABLE_API: "/approve-reject-vendor",


  //Reject Request



  REJECT_ENABLE_DISABLE_SAGA: "REJECT_ENABLE_DISABLE_SAGA",
  REJECT_ENABLE_DISABLE_REQUEST: "REJECT_ENABLE_DISABLE_REQUEST",
  REJECT_ENABLE_DISABLE_RESPONSE: "REJECT_ENABLE_DISABLE_RESPONSE",
  REJECT_ENABLE_DISABLE_API: "/approve-reject-vendor",

// Vendor Enable Disable

VENDOR_ENABLE_DISABLE_SAGA: "VENDOR_ENABLE_DISABLE_SAGA",
  VENDOR_ENABLE_DISABLE_REQUEST: "VENDOR_ENABLE_DISABLE_REQUEST",
  VENDOR_ENABLE_DISABLE_RESPONSE: "VENDOR_ENABLE_DISABLE_RESPONSE",
  VENDOR_ENABLE_DISABLE_API: "/enable-disable-vendor",

  
};
